import { useEffect } from 'react';

/** Strip day/night site theme on admin pages so the login form is visible. */
export function useAdminPage() {
  useEffect(() => {
    document.documentElement.classList.add('admin-route');
    document.body.classList.add('admin-route');
    document.documentElement.classList.remove('daytime', 'nighttime');
    document.body.classList.remove('daytime', 'nighttime');

    return () => {
      document.documentElement.classList.remove('admin-route');
      document.body.classList.remove('admin-route');
    };
  }, []);
}
